import { BarElement, CategoryScale, Chart, LinearScale, Tooltip } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import React from 'react';
import './StarRatingsChart.scss';

Chart.register(BarElement, Tooltip, LinearScale, CategoryScale);

export const StarRatingsChart = ({ starCounts, height = 150, headerData, skipLabels = [] }) => {
  const data = {
    labels: ['☆☆☆☆☆', '☆☆☆☆', '☆☆☆', '☆☆', '☆'],
    datasets: [],
  };

  let labels = Object.keys(starCounts);
  let numSets = labels.length;
  for (let i = 0; i < numSets; i++) {
    const label = labels[i];
    let series;
    series = [...starCounts[label]];
    data.datasets.push({
      label,
      data: series.reverse(),
      backgroundColor: `rgba(255, 195, 0, ${Math.pow(0.5, numSets - 1 - i)})`,
    });
  }

  let maxCount = 0;

  const ratings = ['Total', ...labels]
    .map((label) => {
      if (!skipLabels.includes(label)) {
        let data = [0, 0, 0, 0, 0];
        let total = 0;
        if (label === 'Total') {
          labels.forEach((label) => {
            let labelData = starCounts[label];
            labelData.forEach((val, index) => {
              data[index] += val;
              total += val;
            });
          });
          maxCount = Math.max(...data);
        } else {
          data = starCounts[label];
          total = data[0] + data[1] + data[2] + data[3] + data[4];
        }
        let rating = '0.0';
        if (total > 0) {
          rating = (
            (data[0] + data[1] * 2 + data[2] * 3 + data[3] * 4 + data[4] * 5) /
            total
          ).toFixed(1);
        }
        return { label, rating, total };
      } else return undefined;
    })
    .filter((data) => !!data);

  const options = {
    maintainAspectRatio: false,
    indexAxis: 'y',
    elements: {
      bar: {
        borderWidth: 0,
      },
    },
    responsive: false,
    scales: {
      x: {
        stacked: true,
        display: false,
        max: maxCount,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        mode: 'y',
        callbacks: {
          label: (item) => {
            const label = item.dataset.label;
            return `${label}: ${item.formattedValue}`;
          },
        },
      },
    },
  };

  return (
    <div className="star-ratings-chart">
      <div className="row-top">
        {headerData}
        <table>
          <tbody>
            <tr>
              {ratings.map((r) => (
                <td key={r.label}>
                  <h1>
                    {r.rating}
                    <small> ({r.total})</small>
                  </h1>
                  <p>{r.label}</p>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
      <Bar options={options} data={data} />
    </div>
  );
};

export default StarRatingsChart;
